import {
  ADD_APPROVAL,
  ADD_MESSAGE,
  CLOSE_APPROVAL,
  CLOSE_MESSAGE,
} from './types';

interface IApproval {
  callback: () => void;
  message: string;
}

interface IState {
  approvals: IApproval[];
  messages: string[];
}

const initialState = {
  approvals: [],
  messages: [],
};

export default (
  state: IState = initialState,
  action: {
    approval: IApproval;
    message: string;
    type: string;
  }
): IState => {
  if (action.type === ADD_APPROVAL) {
    return {
      ...state,
      approvals: [...state.approvals, action.approval],
    };
  }

  if (action.type === ADD_MESSAGE) {
    return {
      ...state,
      messages: [...state.messages, action.message],
    };
  }

  if (action.type === CLOSE_APPROVAL) {
    const currentApprovals = [...state.approvals];
    currentApprovals.shift();
    return {
      ...state,
      approvals: currentApprovals,
    };
  }

  if (action.type === CLOSE_MESSAGE) {
    const currentMessages = [...state.messages];
    currentMessages.shift();
    return {
      ...state,
      messages: currentMessages,
    };
  }

  return state;
};
